export default {
  namespaced: true,

  state: () => ({
    externalProducts: {
      data: [],
      links: {},
      meta: {},
    },
    registryUser: {
      data: [],
      links: {},
      meta: {},
    },
    isLoading: false,
  }),

  mutations: {
    SET_PRODUCT_EXTERNAL(state, payload) {
      state.externalProducts = payload
    },
    SET_USER_REGISTRY(state, payload) {
      state.registryUser = payload
    },
    SET_LOADING(state, value) {
      state.isLoading = value
    },
  },

  actions: {
    async getProductExternal({ commit }, {
      page = 1,
      limit = 20,
      sort = '-created_at',
    //   hasUnchangedUrl = null,
    } = {}) {
      try {
        commit('SET_LOADING', true)
        const url = '/v1/admin/get-external-product-registry'

        const response = await this._vm.$http.get(url, {
          params: {
            page,
            limit,
            sort,
          },
        })

        commit('SET_PRODUCT_EXTERNAL', response.data)
        commit('SET_LOADING', false)

        return response.data.data
      } catch (error) {
        commit('SET_LOADING', false)
        return error
      }
    },
    async getRegistryUser({ commit }, {
      page = 1,
      limit = 20,
      sort = '-created_at',
    } = {}) {
      try {
        commit('SET_LOADING', true)
        const url = '/v1/admin/get-user-with-most-purchased-registry'

        const response = await this._vm.$http.get(url, {
          params: {
            page,
            limit,
            sort,
          },
        })

        commit('SET_USER_REGISTRY', response.data)
        commit('SET_LOADING', false)

        return response.data.data
      } catch (error) {
        commit('SET_LOADING', false)
        return error
      }
    },
  },
}
